import React, { useEffect } from 'react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import HealthServices from '../components/HealthServices';
import healthEnergyImg from '../assets/icons/health-energy.webp';

const HealthEnergyPage = () => {
  useEffect(() => {
    try {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    } catch (e) {
      window.scrollTo(0, 0);
    }
  }, []);
  return (
    <div className="health-energy-page">
      <Navigation />
      
  <section className="bg-sand text-indigoDeep pt-20 pb-8">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-12">
            <h1 className="font-serif text-5xl lg:text-6xl mb-6 text-indigoDeep">
              <img src={healthEnergyImg} alt="Health & Energy" className="page-header-icon" />
              Health & Energy
            </h1>
            <p className="text-xl text-grayWarm max-w-3xl mx-auto leading-relaxed">
              Align your health and vitality with your cosmic blueprint. Discover your natural energy rhythms, 
              stress patterns, and optimal healing windows through personalized astrology.
            </p>
          </div>
        </div>
      </section>

      <HealthServices />

      <Footer />
    </div>
  );
};

export default HealthEnergyPage;
